// Social accounts (PR 1 of the first-party social connectors): where accounts
// are listed, followed and connected, what Shadow and Live mean, and the X
// spend cap. It opens the Follow dialog and stops there: it never clicks
// Follow, Connect or Make live, each of which starts a read or a redirect.
// Opened on the page itself: /admin/<customer>/social-accounts?walkthrough=social-accounts.

import type { Walkthrough } from './types'

export const socialAccounts: Walkthrough = {
  slug: 'social-accounts',
  title: 'Social accounts',
  summary:
    'Shows where social accounts are followed or connected, what Shadow and Live mean, how the X spend cap works, and opens the form to follow a public account. Nothing is followed, connected or saved.',
  added: '2026-10-22',
  skipE2E: 'needs the social settings on the server (PLATINUM_WAREHOUSE_MASTER_KEY) and an admin session for a customer with a job',
  steps: [
    {
      route: 'admin-social-accounts',
      feature: 'operations/social-accounts',
      say: 'This is Social accounts, under Management in the Admin menu. It lists every account whose posts and comments Platinum imports for this customer, each with its job, department, status and when it last imported.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/follow-public-account',
      control: 'Follow a public account…',
      say: 'Following reads a public account’s posts and comments with Platinum’s own app. It needs nobody’s approval and adds no private metrics.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/connect-account',
      control: 'Connect X',
      say: 'Connecting sends the account’s owner to the platform to approve Platinum, and adds private metrics. Facebook, Instagram and TikTok are greyed out until each platform approves Platinum; hover over one to see why.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/follow-public-account',
      click: 'Follow a public account…',
      say: 'Opening the form. Nothing is followed until you select Follow.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/follow-public-account',
      control: 'Handle or URL',
      say: 'Type the handle or paste the account’s link, then choose the job, a department and a start date. For X the form says what reading back to the start date will cost.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/follow-public-account',
      click: 'Cancel',
      say: 'Closing the form without following anything.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/account-stage',
      control: 'Make live',
      say: 'A new account starts in Shadow: its data is imported and checked against Sprinklr but not counted on the dashboards. Live means it is counted on the dashboards and sent to coding. Make live on a row is the step that changes what the dashboards show.',
    },
    {
      route: 'admin-social-accounts',
      feature: 'operations/x-spend-cap',
      control: 'Edit cap',
      say: 'X charges for every post and reply read. This line shows this month’s spend against the monthly cap. When the month reaches the cap, X accounts pause. Edit cap changes it.',
    },
  ],
}
